import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMessage = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		stroke: "none",
		strokeWidth: 1,
		fill: "var(--main-color)",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M19 3H5a3 3 0 00-3 3v15a1 1 0 001.51.86L8 19.14a1 1 0 01.55-.14H19a3 3 0 003-3V6a3 3 0 00-3-3zm1 13a1 1 0 01-1 1H8.55a3 3 0 00-1.55.43l-3 1.8V6a1 1 0 011-1h14a1 1 0 011 1v10z",
			fillRule: "nonzero"
		})
	})
});
export { SvgMessage as ReactComponent };
